<template>
  <div class="form-progress-wrap edit-profile basic-info-wrap">
    <div class="container">
      <div class="steps-content">
        <div class="general-form-wrap player-detail-form-wrap box-wrapper">
          <div class="heading padding-top-1">
            <h2 class="form-title">Change Password</h2>
          </div>
          <div class="input-wrapper">
            <FormModel
              layout="horizontal"
              ref="form"
              :form="form"
              :model="resource"
              @submit.prevent.native="handlePasswordChange"
              :rules="validationRules"
            >
              <a-row :gutter="32">
                <a-col>
                  <BaseFormInput
                    label="Current Password"
                    name="oldPassword"
                    placeholder="Enter Current Password"
                    type="password"
                    :value="resource.oldPassword"
                    @change="event => handlePasswordInput(event, 'oldPassword')"
                  />
                  <BaseFormInput
                    label="New Password"
                    name="newPassword"
                    placeholder="Enter New Password"
                    type="password"
                    :value="resource.newPassword"
                    @change="event => handlePasswordInput(event, 'newPassword')"
                  />
                  <BaseFormInput
                    label="Confirm Password"
                    name="confirmPassword"
                    placeholder="Confirm New Password"
                    type="password"
                    :value="resource.confirmPassword"
                    @change="
                      event => handlePasswordInput(event, 'confirmPassword')
                    "
                  />
                  <BaseButton
                    type="primary"
                    class="margin-bottom-1"
                    :loading="changePasswordLoading"
                    :disabled="
                      Boolean(
                        !this.resource.oldPassword ||
                          !this.resource.newPassword ||
                          !this.resource.confirmPassword
                      )
                    "
                    html-type="submit"
                    >Submit
                  </BaseButton>
                </a-col>
              </a-row>
            </FormModel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { User } from "@/models";
import { FormModel } from "ant-design-vue";

const USER_STORE_KEY = "userStore";

export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      form: this.$form.createForm(this),
      validationRules: User.validationRules,
      resource: new User({})
    };
  },
  components: {
    FormModel
  },
  computed: {
    ...mapGetters({
      changePassword: `${USER_STORE_KEY}/changePassword`,
      changePasswordLoading: `${USER_STORE_KEY}/changePasswordLoading`
    })
  },
  methods: {
    handlePasswordInput(event, type) {
      this.resource = { ...this.resource, [type]: event.target.value };
    },
    async handlePasswordChange() {
      if (
        !this.resource.oldPassword ||
        !this.resource.newPassword ||
        !this.resource.confirmPassword
      )
        return;
      let data = {
        passwordCurrent: this.resource.oldPassword,
        password: this.resource.newPassword,
        passwordConfirm: this.resource.confirmPassword
      };
      if (this.resource.newPassword != this.resource.confirmPassword) {
        this.$notification.error({
          message: "Error",
          description: "New Passwords donot match"
        });
      } else {
        await this.$store.dispatch(`${USER_STORE_KEY}/changePassword`, data);
        this.clearFields();
        localStorage["token"] = JSON.stringify(this.changePassword.token);
        this.$notification.success({
          message: "Password Changed Sucessfully"
        });
      }
    },
    clearFields() {
      this.resource.confirmPassword = null;
      this.resource.newPassword = null;
      this.resource.oldPassword = null;
    }
  }
};
</script>

<style lang="sass" scoped>
.steps-content
  text-align: -webkit-center
  .general-form-wrap
    padding: 2rem
  .input-wrapper
    display: flex
    justify-content: center
    padding: 40px 40px
    border-radius: 6px
    background: #f0f0f0
    border: 1px dashed #e9e9e9
    .ant-form-horizontal
      width: 35rem
</style>
